import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form" }
const _hoisted_2 = { class: "base-form" }
const _hoisted_3 = { class: "base-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 18,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.isPickerModeEnabled ? 'Выбор сотрудника' : 'Сотрудники'), 1),
              (!_ctx.isPickerModeEnabled)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    icon: _ctx.circleIcon,
                    size: "large",
                    onClick: _ctx.onAddUserClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Новый сотрудник ")
                    ]),
                    _: 1
                  }, 8, ["icon", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 4,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.tablePositionsFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tablePositionsFilter) = $event)),
                multiple: "",
                placeholder: "Фильтр по должностям"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeePositions, (p) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: p.id,
                      value: p.id,
                      label: p.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createTextVNode("   ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 8,
          style: {"text-align":"right"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.tableSearchQuery,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableSearchQuery) = $event)),
                style: {"max-width":"600px"},
                placeholder: "Поиск по имени, фамилии, отчеству, телефону или e-mail",
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tableRef",
              "row-key": "id",
              sortable: "custom",
              data: _ctx.tableData,
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
              onRowClick: _ctx.onTableRowClick,
              onSortChange: _ctx.onTableSortingChange
            }, {
              default: _withCtx(() => [
                (!_ctx.isPickerModeEnabled)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      type: "selection"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isPickerModeEnabled && _ctx.pickerModeOnItemPickedHandler)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      width: "100",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: (e) => _ctx.pickerModeOnItemPickedHandler(scope.row)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Выбрать ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  width: "80",
                  label: "№",
                  align: "center",
                  sortable: "",
                  prop: "id",
                  "column-key": "id"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Дата создания",
                  formatter: (r) => _ctx.dateFormatter(r.date),
                  sortable: "",
                  prop: "id",
                  "column-key": "id"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Фамилия",
                  sortable: "",
                  prop: "lastname",
                  "column-key": "lastname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Имя",
                  prop: "firstname",
                  sortable: "",
                  "column-key": "firstname"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Отчество",
                  prop: "middlename",
                  sortable: "",
                  "column-key": "middlename"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Дата приема",
                  formatter: (r) => _ctx.dateFormatter(r.hireDate),
                  sortable: "",
                  prop: "hireDate",
                  "column-key": "hireDate"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "200",
                  label: "Должность, грейд",
                  sortable: "",
                  prop: "position",
                  "column-key": "position"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.position.name) + " ", 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_text, {
                        type: "info",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.positionGrade?.name), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  width: "200",
                  label: "Дата рождения",
                  formatter: (r) => _ctx.dateFormatter(r.birthdate),
                  sortable: "",
                  prop: "birthdate",
                  "column-key": "birthdate"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  width: "200",
                  label: "Телефон",
                  prop: "phone"
                }),
                (!_ctx.isPickerModeEnabled)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      width: "200",
                      label: "Пользователь",
                      "column-key": "user"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.user?.login), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data", "default-sort", "onRowClick", "onSortChange"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}